<template>
    <vx-card class="details-card variant-item" :class="{'no-edit': published && cantEditPublished}">
        <div class="vx-card__header px-0 py-0 pb-2">
            <div class="vx-card__title">
                <h4 class="">{{item.name}}</h4>
            </div>
        </div>
        <div v-if="item.language && item.language !== 'none'" class="vs-con-dropdown parent-dropdown cursor-pointer v-lang">
          {{ item.language }}
        </div>
        <vx-tooltip
            class="vs-con-dropdown parent-dropdown cursor-pointer info"
            position="right"
            :text="(item.coobo_library_link_queue ? `<div>Library link queue status: ${item.coobo_library_link_queue.status}, updatedAt: ${getDateFormat(item.coobo_library_link_queue.updatedAt)}</div>` : '') +
                (item.coobo_library_link_priority_queue ? `<div>Library link queue status: ${item.coobo_library_link_priority_queue.status}, updatedAt: ${getDateFormat(item.coobo_library_link_priority_queue.updatedAt)}</div>` : '') +
                (item.coobo_library_thumb_queue ? `<div>Thumbnail queue status: ${item.coobo_library_thumb_queue.status}, updatedAt: ${getDateFormat(item.coobo_library_thumb_queue.updatedAt)}</div>` : '') +
                (item.video_thumb_queue ? `<div>Video thumbnails queue status: ${item.video_thumb_queue.status}, updatedAt: ${getDateFormat(item.video_thumb_queue.updatedAt)}</div>` : '') +
                (!item.coobo_library_link_priority_queue && !item.coobo_library_link_queue && !item.coobo_library_thumb_queue && !item.video_thumb_queue ? 'No queue data' : '')
            ">
            <i class="material-icons notranslate"> info </i>
        </vx-tooltip>
        <button v-if="published" class="vs-con-dropdown parent-dropdown cursor-pointer publish active" @click="() => {editMode && setPublished(item)}">
            <i class="material-icons"> star </i>
        </button>
        <button v-if="!published" class="vs-con-dropdown parent-dropdown cursor-pointer publish" @click="() => {editMode && setPublished(item)}">
            <i class="material-icons"> star_outline </i>
        </button>
        <button class="vs-con-dropdown parent-dropdown cursor-pointer ignore-no-edit" @click="viewDetails = !viewDetails">
            <feather-icon icon="MenuIcon" class="cursor-pointer"
                          svgClasses="w-6 h-6"></feather-icon>
        </button>
        <div class="relative d-flex column flex-grow" style="min-height: 300px; overflow: hidden " :class="{'view-details': viewDetails}">
            <div class="d-flex column flex-grow front-view">
                <h6 style="color: rgb(184, 194, 204);" class="pb-4">{{item.description}}</h6>
                <div class="d-flex column flex-grow">
                    <div class="card-img-block">
                        <HoverThumb
                            :id="'variant' + index + '-thumb'"
                            :main="item.thumbnail"
                            :style="{cursor: assetPopupData ? 'pointer' : 'default'}"
                            :onClick="() => {Boolean(assetPopupData) && openAssetPopup(assetPopupData,index)}"
                            :list="item.thumbnails"/>
                    </div>
                    <div>
                        <div class="mt-2"></div>
                        <div class="flex justify-between flex-wrap variation-btns">
                            <vs-button type="gradient" color="#7367F0" gradient-color-secondary="#CE9FFC"
                                       style="width: 45%; flex-grow: 1"
                                       class="ignore-no-edit"
                                       @click="shareActive = true"
                                       v-if="$store.state.user.role.name !== 'Authenticated'"
                            >
                                <span>Share</span>
                            </vs-button>
                            <span style="width: 10px;" v-if="assetPopupData && $store.state.user.role.name !== 'Authenticated'"></span>
                            <vs-button v-if="assetPopupData" class="ignore-no-edit" type="gradient" color="#7367F0" gradient-color-secondary="#CE9FFC"
                                       style="width: 45%; flex-grow: 1"
                                       @click="openAssetPopup(assetPopupData, index)">View asset
                            </vs-button>
                        </div>
                        <div class="mt-2"></div>
                        <div class="flex justify-between flex-wrap variation-btns" :class="{'no-edit': $store.state.user.role.name !== 'Media' && $store.state.user.role.name !== 'Manager'}">
                            <vs-progress :percent="progressValue( 'source')" color="dark"
                                         v-if="progressData['source']"></vs-progress>
                            <vs-button type="gradient" color="#7367F0" gradient-color-secondary="#CE9FFC"
                                       style="flex-grow: 1;"
                                       @click="download(item.source_links,  'source')"
                                       :class="`download-source-${index}`"
                                       v-if="item.source_links && item.source_links.length > 0"
                            >
                            <span
                                v-if="!progressData['source']">Download Source{{getLinksSize(item.source_links)}}</span>
                                <span v-else>{{downloadedStr(progressData['source'])}}</span>
                            </vs-button>
                        </div>
                        <div class="mt-2"></div>
                        <div class="flex justify-between flex-wrap variation-btns" :class="{'no-edit': $store.state.user.role.name !== 'Media' && $store.state.user.role.name !== 'Manager'}">
                            <vs-progress :percent="progressValue('ready')" color="dark"
                                         v-if="progressData['ready']"></vs-progress>
                            <vs-button type="gradient" color="#7367F0"
                                       gradient-color-secondary="#CE9FFC" style="flex-grow: 1;"
                                       @click="download(item.ready_links,  'ready')"
                                       v-if="item.ready_links && item.ready_links.length > 0"
                                       :class="`download-ready-${index} coobo-ready-btn`">
                            <span
                                v-if="!progressData['ready']">Download Coobo-ready{{getLinksSize(item.ready_links)}}</span>
                                <span v-else>{{downloadedStr(progressData['ready'])}}</span>

                            </vs-button>
                        </div>
                        <div class="mt-2"></div>
                        <div class="flex justify-between flex-wrap variation-btns" :class="{'no-edit': $store.state.user.role.name !== 'Media' && $store.state.user.role.name !== 'Manager'}">
                            <vs-progress :percent="progressValue('ar')" color="dark"
                                         v-if="progressData['ar']"></vs-progress>
                            <vs-button type="gradient" color="#7367F0"
                                       gradient-color-secondary="#CE9FFC" style="flex-grow: 1;"
                                       @click="download(item.ar_links,  'ar')"
                                       v-if="item.ar_links && item.ar_links.length > 0"
                                       :class="`download-ar-${index} coobo-ready-btn`">
                            <span
                                v-if="!progressData['ar']">Download Ar-ready{{getLinksSize(item.ar_links)}}</span>
                                <span v-else>{{downloadedStr(progressData['ar'])}}</span>

                            </vs-button>
                        </div>
                        <!--                                <div class="mt-2"></div>-->
                        <!--                                <div class="flex justify-between flex-wrap variation-btns" v-if="item.coobo_library_link">-->
                        <!--                                    <vs-button type="gradient" color="#7367F0" gradient-color-secondary="#CE9FFC"-->
                        <!--                                               @click="openHierarchyPopup(item.coobo_library_link)"-->
                        <!--                                               style="width: 100%">View Object Hierarchy-->
                        <!--                                    </vs-button>-->
                        <!--                                </div>-->
                    </div>
                </div>
            </div>
            <div class="d-flex column flex-grow hidden-view" >
                <ObjectHierarchy :tabs="true" :coobo-asset-id="item.coobo_library_link.split('/').pop().split('?')[0]" v-if="item.coobo_library_link"/>
                <div class="drop-down-field">Variation id: {{ item._id }}</div>
                <div class="drop-down-field">Updated by: {{ item.approved_by }}</div>
                <div class="drop-down-field">Last updated: {{ getDateFormat(item.updatedAt) }}
                </div>
                <div class="drop-down-field" v-if="item.visual_style">Visual Style: {{ item.visual_style }}
                </div>
                <vs-divider style="margin: 0"/>
                <div class="drop-down-field">Is animated: {{ item.is_animated ? 'Yes' : 'No'
                    }}
                </div>
                <div class="drop-down-field">Language: {{ item.language }}</div>
                <div class="drop-down-field" v-if="item.duration">Duration: {{ getDuration(item.duration) }}</div>
                <vs-divider style="margin: 0"/>
                <div class="drop-down-field" v-if="item.notes">Notes: {{ item.notes }}</div>
                <vs-divider style="margin: 0"/>
                <div>

                    <!-- <div class="mt-2"></div>
                    <div class="flex justify-between flex-wrap variation-btns" v-if="editMode">
                        <vs-button type="gradient" color="#7367F0" gradient-color-secondary="#CE9FFC"
                                    style="width: 45%; flex-grow: 1"
                                    @click="viewVariation(item)">
                            <span>View Asset</span>
                        </vs-button>
                    </div> -->

                    <!-- <div class="mt-2"></div>
                    <div class="flex justify-between flex-wrap variation-btns" v-if="editMode">
                        <vs-button type="gradient" color="#7367F0" gradient-color-secondary="#CE9FFC"
                                    style="width: 45%; flex-grow: 1"
                                    @click="uploadVariantThumb(item)">
                            <span>Upload thumbnail</span>
                        </vs-button>
                    </div> -->
                    <div class="mt-2"></div>
                    <div class="flex justify-between flex-wrap variation-btns" v-if="item.coobo_library_link && editMode">
                        <a :href="item.coobo_library_link.replace(/view_asset/gi, 'edit_asset')" target="_blank"
                           style="width: 45%; flex-grow: 1" class="d-flex">
                            <vs-button
                                class="shadow-lg "
                                type="gradient" color="#7367F0"
                                gradient-color-secondary="#CE9FFC"
                                style="flex-grow: 1"
                            >Materials
                            </vs-button>
                        </a>
                        <span style="width: 10px;" v-if="assetPopupData"></span>
                        <a :href="item.coobo_library_link.replace(/view_asset/gi, 'edit_hierarchy_translation')"
                           target="_blank" style="width: 45%; flex-grow: 1" class="d-flex" :class="{'ignore-no-edit': $store.state.user.role.name === 'CopyEditors'}">
                            <vs-button class="shadow-lg" :class="{'ignore-no-edit': $store.state.user.role.name === 'CopyEditors'}" type="gradient" color="#7367F0"
                                       style="flex-grow: 1"
                                       gradient-color-secondary="#CE9FFC">Labels & Translation
                            </vs-button>
                        </a>
                    </div>
                    <div class="mt-2"></div>
                    <div class="flex justify-between flex-wrap variation-btns" v-if="editMode">
                        <vs-button type="gradient" color="#7367F0" gradient-color-secondary="#CE9FFC"
                                    style="width: 45%; flex-grow: 1"
                                    @click="edit(item)">

                            <span>Edit Details</span>
                        </vs-button>
                    </div>
                    <div class="mt-2"></div>
                    <div class="flex justify-between flex-wrap variation-btns" v-if="editMode">
                        <vs-button type="gradient" color="#7367F0" gradient-color-secondary="#CE9FFC"
                                    style="width: 45%; flex-grow: 1"
                                    @click="del(item, 'variants')"
                                    v-if="$store.state.user.role.name === 'Manager'">

                            <span>Delete Variation</span>
                        </vs-button>
                    </div>
                    <div class="mt-2"></div>
                    <div class="flex justify-between flex-wrap variation-btns" v-if="editMode && asset.asset_type !== '3D'">
                        <vs-button type="gradient" color="#7367F0" gradient-color-secondary="#CE9FFC"
                                    style="width: 45%; flex-grow: 1"
                                   :disabled="isSyncThumbnail"
                                    @click="syncVariationThumb(item)"
                                    v-if="$store.state.user.role.name === 'Manager'">

                            <span>Sync thumbnails</span>
                        </vs-button>
                    </div>
                    <div class="mt-2"></div>
                    <div class="flex justify-between flex-wrap variation-btns" v-if="editMode && item.coobo_library_link">
                        <vs-button type="gradient" color="#7367F0" gradient-color-secondary="#CE9FFC"
                                    style="width: 45%; flex-grow: 1"
                                    @click="createQuestion(item)">

                      <span>Create simulation question in CG</span>
                    </vs-button>
                    </div>
                </div>
            </div>
        </div>
        <vs-popup class="holamundo" title="Share" :active.sync="shareActive">
            <p class="text-center" style="user-select: all; cursor: pointer" @click="copyToClipboard(shareLink)">
                <vs-input
                    @click="copyToClipboard(shareLink)"
                    icon-after="true"
                    icon="content_copy"
                    class="text-center copy-icon no-transparent"
                    style="user-select: all; cursor: pointer; width: 100%"
                    :disabled="true"
                    placeholder=""
                    :value="shareLink"
                />
            <div class="d-flex mt-4">
                <vs-button type="gradient" color="#7367F0" gradient-color-secondary="#CE9FFC"
                           style="margin-left: auto"
                           @click="shareActive = false"
                >
                    <span>Close</span>
                </vs-button>
            </div>
        </vs-popup>
    </vx-card>
</template>

<script>

    import axios from "axios";
    import ObjectHierarchy from "../components/ObjectHierarchy";
    import HoverThumb from "../components/HoverThumb";

    export default {
        name: "VariantItem",
        components: {
            HoverThumb,
            ObjectHierarchy,
        },
        props: {
            editMode: {type: Boolean},
            published: {type: Boolean, default: false},
            item: {type: Object},
            index: {type: Number},
            asset: {type: Object},
            edit: {type: Function, required: false},
            del: {type: Function, required: false},
            createQuestion: {type: Function, required: false},
            updateAssetThumb: {type: Function, required: false},
            openAssetPopup: {type: Function, required: false},
            setPublished: {type: Function, required: false},
            syncVariationThumb: {type: Function, required: false},
            cantEditPublished: {type: Boolean, required: false},
            isSyncThumbnail: {type: Boolean, default: false},
        },
        data() {
            return {
                shareActive: false,
                viewDetails: false,
                progressData: {
                    source: null,
                    ready: null
                },
            }
        },
        computed: {
            shareLink() {
                return `${window.location.origin}/${this.asset._id}/${this.item._id}`
            },
            thumbnail() {
                let item = this.item;
                return item.thumbnail ? item.thumbnail : this.$store.state.defaultThumbnail;
            },
            assetPopupData() {
                if (typeof this.openAssetPopup !== "function") return null;
                let data = this.item;
                let assetPopupData = null;
                let ready_links = data.ready_links ? data.ready_links : [];
                let source_links = data.source_links ? data.source_links : [];
                switch (this.asset.asset_type) {
                    case "3D": {
                        if (data.coobo_library_link) {
                            assetPopupData = {variants_data: data};
                        }
                        break;
                    }
                    case "image":
                    case "illustration": {
                        let images = [...ready_links, ...source_links].filter(l => l.mime && l.mime.indexOf("image") !== -1)
                        if (images[0] && images[0].url) {
                            assetPopupData = images[0].url;
                            break;
                        }
                        break;
                    }
                    case "vr_image": {
                        let images = ready_links.filter(l => l.mime && l.mime.indexOf("image") !== -1)
                        if (images[0] && images[0].url) {
                            assetPopupData = `/panorama-viewer/viewer.html?panorama=${images[0].url}&autoLoad=true&autoRotate=2`;
                            break;
                        }
                        break;
                    }
                    case "video":
                    case "animation": {
                        let videos = [...ready_links, ...source_links].filter(l => l.mime && l.mime.indexOf("video") !== -1)
                        if (videos[0] && videos[0].url) {
                            assetPopupData = videos[0].url;
                            break;
                        }
                        break;
                    }
                    case "audio": {
                        let audios = [...ready_links, ...source_links].filter(l => l.mime && l.mime.indexOf("audio") !== -1)
                        if (audios[0] && audios[0].url) {
                            assetPopupData = {src: audios[0].url, filename: `${audios[0].name}${audios[0].ext}`};
                            break;
                        }
                        break;
                    }
                    default: {
                        assetPopupData = null;
                    }
                }
                return assetPopupData
            },
            progressValue() {
                return (type) => {
                    let value = 0;
                    if (this.progressData[type]) {
                        let filesData = this.progressData[type].data;
                        let zipData = this.progressData[type].zip_data;
                        if (zipData && zipData.total) {
                            let zipPercent = zipData.total / zipData.files / 4;
                            value = 75 + zipPercent;
                        } else if (filesData && Object.values(filesData).length > 0) {
                            let filesCount = Object.values(filesData).length;
                            value = Object.values(filesData).reduce((a, b) => a + b, 0) / filesCount * 0.75;
                        }
                    }

                    return value;
                }
            }

        },
        mounted() {
        },
        methods: {
            copyToClipboard(val) {
                document.execCommand("copy");
                this.$vs.notifyWrapper({color: 'success', title: 'Copied to clipboard.'})
            },
            uploadVariantThumb(variant) {
                console.log("this.asset",this.asset);
                console.log("variant",variant);
                let input = document.createElement("input");
                input.type = "file";
                input.accept = ".jpg, .jpeg, .png, .gif";
                input.click();
                document.body.click();
                input.addEventListener("change", (e) => {
                    this.$root.addLoading(`#variant${this.index}-thumb`);
                    let thumb = e.target.files[0];
                    let formData = new FormData();
                    formData.append("files", thumb);
                    this.$axios.post('/' + this.$store.state.filesUrl, formData).then(res => {
                        if (res.data && res.data[0]) {
                            let thumb = res.data[0].formats && res.data[0].formats.small ? res.data[0].formats.small.url : res.data[0].url;
                            if (this.asset.thumbnail === variant.thumbnail) {
                                this.updateAssetThumb(thumb);
                            }
                            variant.thumbnail = thumb;
                            let url = '/variants/' + variant._id;
                            this.$axios.put(url, variant).then(res => {
                                this.setThumbDropdownOpts()
                                let tempImg = new Image();
                                tempImg.onload = () => {
                                    this.$root.removeLoading(`#variant${this.index}-thumb`);
                                    tempImg.remove();
                                }
                                tempImg.src = variant.thumbnail;
                            }).catch(e => {
                              this.$vs.notifyWrapper({color: 'danger', fixed: true, title: 'Error', text: e.message || e})
                              this.$root.removeLoading(`#variant${this.index}-thumb`);
                            })
                        }
                    }).catch(e => {
                      this.$vs.notifyWrapper({color: 'danger', fixed: true, title: 'Error', text: e.message || e})
                      this.$root.removeLoading(`#variant${this.index}-thumb`);
                    })
                    input.remove();
                })
            },
            viewVariation(item) {
                this.isSaved = true;

                this.$router.push("/" + this.asset._id + '/' + item._id)
            },
            getLinksSize(links, isFull) {
                let size = links.reduce((acc, val) => acc + val.size, 0) / 1024;
                return size ? isFull ? size : `(${Math.round(size * 10) / 10 || "<1"}MB)` : ""
            },
            download(links, type) {
                if (this.progressData[type]) {
                    return;
                }
                this.sendDownloadAnalytics(type);
                this.$set(this.progressData, type, {
                    data: {},
                    total: {},
                    loaded: {},
                })

                let files = {};
                let promises = [];

                links.forEach((item, index) => {
                    let options = {
                        responseType: 'arraybuffer',
                        onDownloadProgress: (progressEvent) => {
                            const totalLength = progressEvent.lengthComputable ? progressEvent.total : progressEvent.target.getResponseHeader('content-length') || progressEvent.target.getResponseHeader('x-decompressed-content-length');
                            if (totalLength !== null) {
                                this.$set(this.progressData[type].data, index, Math.round((progressEvent.loaded * 100) / totalLength));
                                this.$set(this.progressData[type].total, index, totalLength);
                                this.$set(this.progressData[type].loaded, index, progressEvent.loaded)
                            }
                        },
                        headers: {
                          'Cache-Control': 'no-cache'
                        }
                    };

                    let instance = axios.create();
                    delete instance.defaults.headers.common['Authorization'];

                    promises.push(instance.get(item.url, options).then(res => {
                        files[index] = res.data;
                    }).catch(e => {
                        this.$vs.notifyWrapper({color: 'danger', fixed: true, title: 'Error', text: e.message || e})
                        console.log('download', e)
                    }))
                });

                Promise.all(promises).then(() => {
                    this.$set(this.progressData[type], 'zip_data', {})
                    if (Object.keys(files).length === 1) {
                        const blob = new Blob([files[0]]);
                        const link = document.createElement('a');
                        link.href = URL.createObjectURL(blob);
                        link.download = links[0].name + links[0].ext;
                        link.click();
                        URL.revokeObjectURL(link.href);

                        this.$set(this.progressData[type].zip_data, links[0].name, 100)
                        setTimeout(() => {
                            this.progressData[type] = false;
                        }, 500)
                    } else {
                      if (this.getLinksSize(links, true) > 1000) {
                        for (let k in links) {
                          saveAs(links[k].url, links[k].name + links[k].ext);
                        }
                        setTimeout(() => {
                          this.$set(this.progressData, [type], false);
                        }, 500)
                      } else {
                        let zip = new JSZip();
                        let zipData = {files: links.length, total: 0};
                        for (let k in files) {
                          let name = links[k].name + links[k].ext;

                          if (zip.files[name]) {
                            name = links[k].name + '_' + Math.random().toString(36).substring(5) + links[k].ext;
                          }

                          zip.file(name, files[k]);
                        }
                        this.$set(this.progressData[type], 'zip_data', zipData)
                        let zippedFiles = {};
                        zip.generateAsync({
                          type: "blob",
                          compression: "STORE",
                        }, (metadata) => {
                          if (metadata.currentFile) {
                            let data = Object.assign({}, this.progressData[type].zip_data);
                            zippedFiles[metadata.currentFile] = metadata.percent;
                            data.total = Object.values(zippedFiles).reduce((a, b) => a + b, 0);
                            this.$set(this.progressData[type], 'zip_data', data)
                          }
                        }).then((blob) => {
                          let n = {ready: "coobo", source: "source"}
                          saveAs(blob, `${this.asset.title}_${this.item.name}_${n[type]}.zip`);
                          setTimeout(() => {
                            this.progressData[type] = false;
                          }, 500)
                        }, (err) => {
                          console.log(err);

                        })
                      }
                    }
                });
            },
            sendDownloadAnalytics(type) {
              let types = {
                source: "source",
                ready: "coobo_ready",
                ar: "ar_ready",
              }
              let data = {
                asset_id: this.asset._id,
                variation_id: this.item._id,
                type: types[type],
                user_email: this.$store.state.user.email,
                user_id: this.$store.state.user._id
              }
              this.$axios.post("/download-analytics", data);
            },
            downloadedStr(data) {
                if (data.zip_data && data.zip_data.files) {
                    return `Zipping ${Math.round(data.zip_data.total / data.zip_data.files)}%`;
                }
                let loaded = this.formatNumber(Object.values(data.loaded).reduce((acc, val) => {
                    acc += val;
                    return acc
                }, 0));
                let total = this.formatNumber(Object.values(data.total).reduce((acc, val) => {
                    acc += val;
                    return acc
                }, 0));
                return `Downloaded ${loaded} / ${total}`
            },
            formatNumber(num) {
                const map = [
                    {num: 1024 * 1024, str: " mb"},
                    {num: 1024 * 1024 * 1024, str: " gb"}
                ];

                let str = (num / map[0].num).toFixed(num % map[0].num > 1 ? 2 : 1) + map[0].str;

                map.forEach(m => {
                    if (num >= m.num) {
                        str = (num / m.num).toFixed(num % m.num > 1 ? 2 : 1) + m.str;
                    }
                });

                return num ? str : 0;

            },
            getDateFormat(date) {
                let d = new Date(date);
                return (d.getMonth() + 1) + "/" + d.getDate() + "/" + d.getFullYear() + " " +
                    d.getHours() + ":" + d.getMinutes() + ":" + d.getSeconds();
            },
            formatBytes(files, decimals = 2) {
                let bytes = 0;
                if (!files || !files.length) return '0 KB';

                files.forEach(item => {
                    bytes += item.size;
                })

                const k = 1024;
                const dm = decimals < 0 ? 0 : decimals;
                const sizes = ['KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

                const i = Math.floor(Math.log(bytes) / Math.log(k));
                if (i === -1) {
                    return bytes + ' ' + sizes[0];
                }

                return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
            },
            getDuration(duration) {
                let minutes = Math.floor(duration / 60);
                let seconds = Math.floor(duration - minutes * 60);

                return minutes + ':' + seconds;
            }
        },
    }
</script>
